import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Icon, type IconName } from './icons/index.tsx';
import styles from './MenuTile.module.css';

export interface MenuTileProps {
  to: string;
  icon: IconName;
  title: ReactNode;
  hint?: ReactNode;
  /** Extra marker on the right, e.g. a "soon" badge. */
  badge?: ReactNode;
  primary?: boolean;
  /** Entrance animation delay in ms (staggered menus). */
  index?: number;
}

/** Big tappable row used by the home and play menus. */
export function MenuTile({
  to,
  icon,
  title,
  hint,
  badge,
  primary = false,
  index = 0,
}: MenuTileProps) {
  return (
    <Link
      to={to}
      className={[styles['tile'], primary ? styles['primary'] : ''].join(' ')}
      style={{ animationDelay: `calc(${index} * 55ms / var(--anim-speed))` }}
    >
      <span className={styles['icon']}>
        <Icon name={icon} size="1.6rem" />
      </span>
      <span className={styles['text']}>
        <span className={styles['title']}>{title}</span>
        {hint ? <span className={styles['hint']}>{hint}</span> : null}
      </span>
      {badge ? <span className={styles['badge']}>{badge}</span> : null}
      {badge ? <Icon name="lock" size="1rem" className={styles['lock']} /> : null}
    </Link>
  );
}
